import { createSelector } from 'reselect';

export const hubspotLoginReferralFormSelector = createSelector(
  (state) => state.hubspotform,
  (hubspotform) => {
    return {
      shown: hubspotform.loginReferralForm.show,
    };
  }
);
